import React, {Component} from 'react';
import PropTypes, {object} from 'prop-types';
import {Button, Col, Modal, Row} from 'react-bootstrap';
import {MdClose} from 'react-icons/md';
import Formsy, {withFormsy} from 'formsy-react';
import Input from 'components/Input';
import {formatDate} from 'scripts/dateFormatter';
import classNames from 'classnames';
import Select, {createFilter} from 'react-select';

class MySelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showOptions: false
        };
    }

    changeValue(val) {
        this.props.setValue(val);
    }

    handleInputChange(typedOption) {
        if (typedOption.length > 0) {
            this.setState({ showOptions : true });
        }
        else {
            this.setState({ showOptions : false });
        }
    }

    render() {
        const {props: P} = this;
        const errorMessage = this.props.errorMessage;
        const show_error = !P.isValid && (!P.isPristine || P.isFormSubmitted);

        return <div
            className={'form-group form-row'}
        >
            <label className={
                classNames({
                    'col-form-label': true,
                    'col-3': true,
                    'text-danger': show_error
                })}>
                {P.label}
                {P.required ? <span className={'required-symbol'}> *</span> : null }
            </label>
            <div
                className={'col-9'}
                style={{
                    ...P.style
                }}
            >
                <Select
                    options={ this.state.showOptions ? P.options : [] }
                    isClearable={true}
                    filterOption={createFilter({
                        trim: true,
                        matchFrom: 'start'
                    })}
                    value={P.value}
                    getOptionValue={option => P.getOptionValue(option)}
                    getOptionLabel={option => P.getOptionLabel(option)}
                    onChange={ val => this.changeValue(val)}
                    isDisabled={false}
                    placeholder={'Zvoľte číslo zákazky'}
                    noOptionsMessage={() => 'Zadajte číslo zákazky'}
                    isMulti={false}
                    onInputChange = { (input) => this.handleInputChange(input) }
                    components={{
                        'DropdownIndicator': () => null,
                    }}
                />
                { show_error ?
                    <span
                        className={'invalid-feedback'}
                        style={{display: 'block'}}
                    >
                        { errorMessage }
                    </span> : null
                }
            </div>
        </div>;
    }
}
const FormSelect = withFormsy(MySelect);

class EmployeeOrderForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formSubmitted: false,
        };
    }

    onSubmit(model){
        const {props: P} = this;

        const data = {
            employee_id: P.employee_id,
            order_id: model.order.id,
            date_from: model.date_from || null,
            date_to: model.date_to || null,
        };

        this.setState({
            formSubmitted: true,
        });

        this.props.onSubmit(P.objectToUpdate ? P.objectToUpdate.id : null, data, P.updating);
    }

    render() {
        const {props: P, state: S} = this;

        return (
            <Modal
                onHide={() => P.onClose()}
                show={P.show}>
                <Modal.Header>
                    <div
                        className="closeBox"
                        style={{float: 'right', height: 25}}
                    >
                        <MdClose
                            size={24}
                            onClick={this.props.onClose}
                            style={{cursor: 'pointer'}}
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="register-form">
                        <Formsy
                            onValidSubmit={model => this.onSubmit(model)}
                        >
                            <FormSelect
                                name={'order'}
                                label={'Zákazka'}
                                options={P.orders}
                                getOptionValue={e => e.id}
                                getOptionLabel={e => e.serial_number}
                                value={P.objectToUpdate.order ? P.objectToUpdate.order : null}
                                isFormSubmitted={() => S.formSubmitted}
                                required={true}
                                isClearable={true}
                            />
                            <Input
                                name="date_from"
                                label="Od"
                                type={'date'}
                                value={formatDate(P.objectToUpdate.date_from || '')}
                            />
                            <Input
                                name="date_to"
                                label="Do"
                                type={'date'}
                                value={formatDate(P.objectToUpdate.date_to || '')}
                            />
                            <Row>
                                <Col md={{span: 8, offset: 4}}>
                                    <Button variant="success" type="submit">
                                        {P.updating ? 'Upraviť' : 'Vytvoriť'}
                                    </Button>
                                </Col>
                            </Row>
                        </Formsy>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

EmployeeOrderForm.propTypes = {
    show: PropTypes.bool.isRequired,
    updating: PropTypes.bool.isRequired,
    objectToUpdate: PropTypes.object.isRequired,
    orders: PropTypes.arrayOf(object).isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    employee: PropTypes.object
};

export default EmployeeOrderForm;
